import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const VisibilityOffSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default VisibilityOffSVG;
